export enum ToolboxItemType {
  Offer = 'Offer',
  Promotion = 'Promotion',
  Promocodes = 'Promocodes',
  Reward = 'Reward',
  Punchcard = 'Punchcard',
  Challenge = 'Challenge',
  ProductGroups = 'ProductGroups',
  AwardCatalog = 'AwardCatalog',
  DisplayCategory = 'DisplayCategory',
  ProductCategory = 'ProductCategory',
  FuelRollback = 'FuelRollback',
  Sweepstakes = 'Sweepstakes',
  Billboards = 'Billboards',
  LoyaltyEvents = 'LoyaltyEvents',
  FreeGames = 'Games',
  VoucheredGames = 'Vouchered Games',
  ReferralProgram = 'ReferralProgram',
  SmsOrPushNotification = 'SmsOrPushNotification',
  TriggeredMessages = 'TriggeredMessages',
  StoredValue = 'StoredValue',
}

export type ToolboxBodyProps = {
  title: string;
  description: string;
  type: ToolboxItemType;
};

export type ToolboxActionsProps = {
  type: ToolboxItemType;
  linkToCreate?: string;
  linkToEdit?: string;
  linkToDetails?: string;
  loading?: boolean;
};

type ToolboxView = 'default' | 'link';

export type ToolboxItemProps = ToolboxBodyProps &
  ToolboxActionsProps & {
    viewType?: ToolboxView;
  };
